"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const StatusIndicator_1 = require("../../styled/StatusIndicator");
const react_1 = __importDefault(require("react"));
exports.Indicator = ({ value }) => {
    return (react_1.default.createElement("div", { className: "d-flex justify-content-center" }, value &&
        value.map((x, index) => (react_1.default.createElement(StatusIndicator_1.StatusIndicator, { key: `status-indicator-${x}-${index}`, type: x })))));
};
//# sourceMappingURL=Indicator.js.map